import styled from 'styled-components';

const StyledVisitFormRecommendationsAndContinousMedicineContainer = styled.div`
   display: inline-flex;
   gap: 16px;
   overflow: auto;

   > * {
      width: 100%;
   }
`;
StyledVisitFormRecommendationsAndContinousMedicineContainer.displayName =
   'StyledVisitFormRecommendationsAndContinousMedicineContainer';

export { StyledVisitFormRecommendationsAndContinousMedicineContainer };
